import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import HeroHeader from '../components/About/HeroHeader'
import AboutDetails from '../components/About/AboutDetails'
import AboutChoose from '../components/About/AboutChoose'
import MasonryGallery from '../components/About/Masonry'
import Gallery from '../components/About/Gallery'


const Aboutpage = () => {
    return (
        <div>
        <Navbar/>
        <HeroHeader/>
        <AboutDetails/>
        <AboutChoose/>
   <MasonryGallery/>

   

   


        <Footer/>

        </div>
    )
}

export default Aboutpage